import React from 'react';
import { IdCard, Building2, LogOut } from './Icons';
import userdata from '../config/jwt_token';
import { handleLogout } from '../utils/authHelper';

class AccountDetails extends React.Component {

  logout() {
    handleLogout();
  }

  _getInitials() {
    if (!userdata || !userdata.name) return 'U';
    return userdata.name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
  }

  render() {
    const name    = userdata ? userdata.name    : '';
    const email   = userdata ? userdata.email   : '';
    const empId   = userdata ? userdata.emp_id  : '';
    const dept    = userdata ? userdata.role_label : '';
    const canChangePwd = userdata &&
      (userdata.role.indexOf('Super Central Finance') >= 0 || userdata.role === 'root');

    return (
      <div className="zaps-profile-card">

        {/* ── Coloured header ── */}
        <div className="zaps-profile-header">
          <div className="zaps-profile-avatar-lg">{this._getInitials()}</div>
          <div className="zaps-profile-meta">
            <h4>{name}</h4>
            <p>{email}</p>
          </div>
        </div>

        {/* ── Details ── */}
        <div className="zaps-profile-body">
          {empId && (
            <div className="zaps-profile-row">
              <IdCard size={13} color="#94a3b8" style={{ flexShrink: 0 }} />
              <span>Employee ID: <strong>{empId}</strong></span>
            </div>
          )}
          {dept && (
            <div className="zaps-profile-row">
              <Building2 size={13} color="#94a3b8" style={{ flexShrink: 0 }} />
              <span>{dept}</span>
            </div>
          )}
        </div>

        <div className="zaps-profile-divider" />

        {/* ── Actions ── */}
        <div className="zaps-profile-footer">
          {canChangePwd && (
            <span
              className="zaps-change-pwd-link"
              onClick={this.props.changePassword}
            >
              Change Password
            </span>
          )}
          <button className="zaps-signout-btn" onClick={this.logout}>
            <LogOut size={13} style={{ marginRight: 6 }} />
            Sign Out
          </button>
        </div>

      </div>
    );
  }
}

export default AccountDetails;


// WEBPACK FOOTER //
// ./src/components/AccountDetails.js